import React from 'react';
import ErrorFeedbackBar from '.././global/ErrorFeedbackBar';
import { TICKET_OUT_PAGES } from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { companySelector } from '../../redux/selectors/account';
import { clearStatus } from '../../redux/actions/global';
import { userInfoSelector } from '../../redux/selectors/auth';
import TicketOutTable from './TicketOutTable';
import { Button, TextField } from '@material-ui/core';
import {
  deleteTicketOut,
  getGlobalPDFPreview,
  listTicketOut,
  resetGlobalPdfPreviewData,
  saveTicketOut,
} from '../../redux/actions/ticketOut';
import {
  globalPDFPreviewReadySelector,
  ticketOutSelector,
} from '../../redux/selectors/ticketOut';
import InputAdornment from '@material-ui/core/InputAdornment';
import { DEFAULT_PDF_ZOOM } from '../raffle/constants';
import Utils from '../Utils/Utils';
import RenderPurchaseOrderPDFPreview from '../transaction/RenderPurchaseOrderPDFPreview';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../reading/masterReading/constants';
import { GetApp } from '@material-ui/icons';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomToolbar from '../global/CustomToolbar';

class TicketOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: TICKET_OUT_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      ticketOut: '',
      machine: '',
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      requiredList: ['machine', 'ticketOut'],
      //report
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      saving: false,
      waiting: false,
    };

    this.amountRef = React.createRef();
  }

  componentDidMount() {
    this.props.listTicketOut({
      userId: this.props.user.userId,
      locationId: this.props.user.selectedLocationId,
    });
    if (this.hasTicketNFCRole()) {
      // Get query params from URL
      const queryParams = new URLSearchParams(window.location.search);
      const machine = queryParams.get('machine');

      if (machine) {
        this.setState({ machine }, () => {
          // Focus on amount input
          if (this.amountRef.current) {
            this.amountRef.current.focus();
          }
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }
  }

  handleClick = (value) => {
    this.setState((prevState) => ({
      amounts: {
        ...prevState.amounts,
        [value]: prevState.amounts[value] + 1,
      },
      ticketOut: Number(prevState.ticketOut) + Number(value), // Ensure both are treated as numbers
    }));
  };

  clearAmounts = () => {
    this.setState({
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      ticketOut: '',
    });
  };

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displayTable = () => {
    return (
      <TicketOutTable
        userInfo={this.props.user}
        deleteTicketOut={this.props.deleteTicketOut}
        ticketOut={this.props.ticketOut}
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
        isBonusView={this.state.isBonusView}
        claimBonus={this.props.claimBonus}
        handleEditBonusRow={this.handleEditBonusRow}
        isPreviewImage={this.state.isPreviewImage}
        image={this.state.image}
      />
    );
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case TICKET_OUT_PAGES.TABLE:
        return this.displayTable();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  hasTicketNFCRole = () => {
    const { user, companies } = this.props;
    const roles = user?.authority || [];
    if (!roles.includes('ROLE_TICKET_NFC')) return false;

    // Per-location opt-out: if the currently selected location's company
    // has nfcTicketOutEnabled === false, treat NFC as disabled so the
    // Machine field stays manually editable.
    const locationId = user?.selectedLocationId;
    const currentCompany = (companies || []).find(
      (c) => c.companyId === locationId
    );
    if (currentCompany && currentCompany.nfcTicketOutEnabled === false) {
      return false;
    }
    return true;
  };

  handleChange = (event) => {
    const { name, value } = event.target;

    // Ensure the value is a positive integer or empty
    const reg = /^[0-9\b]+$/; // Regex to allow only digits and empty input (for clearing the field)

    if (value === '' || reg.test(value)) {
      this.setState({ [name]: value });
    }
  };

  clearFields = () => {
    this.setState({ machine: '' }, () => {
      this.clearAmounts();
    });
  };

  addTicket = () => {
    if (this.state.saving || this.state.waiting) return;

    this.setState({ saving: true });

    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', response);
        this.clearFields(); // only clear on success
      }

      // finish saving + start waiting in one atomic update
      this.setState({ saving: false, waiting: true }, () => {
        // wait 2 seconds before allowing next save
        setTimeout(() => {
          this.setState({ waiting: false });
        }, 2000);
      });
    };

    this.props.saveTicketOut(
      {
        machine: this.state.machine,
        ticketOut: this.state.ticketOut,
        userId: this.props.user.userId,
        locationId: this.props.user.selectedLocationId,
        amounts: this.state.amounts,
      },
      callback
    );
  };

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  fetchPdf = async () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    this.props.getGlobalPDFPreview(
      {
        userId: this.props.user.userId,
        locationId: this.props.user.selectedLocationId,
        date: getTodayDate,
      },
      this.showPdfErrorMessage,
      'previewTicketOutReport'
    );
    this.setState({ showPdfViewer: true });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.user.firstname} Ticket Out Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  render() {
    const { amounts, showPdfViewer, pdfData, scale } = this.state;

    let headerButtons;
    headerButtons = [];
    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else {
      if (!this.state.isPreviewImage && !this.state.isMobile) {
        headerButtons.push({
          icon: <VisibilityIcon />,
          title: 'View Report',
          handler: () => this.fetchPdf(),
        });
      }
    }

    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <CustomToolbar
          title={`Ticket Out (${this.props.user.firstname})`}
          createTitle={''}
          backTitle={''}
          headerButtons={headerButtons}
        />

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : (
          <>
            <div className="rowSpecMaster">
              <TextField
                className="input-text-field"
                variant="outlined"
                label="Machine"
                InputLabelProps={{ shrink: true }}
                name="machine"
                value={this.state.machine}
                onChange={this.handleChange}
                required={this.state.requiredList.includes('machine')}
                type="tel"
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  min: '0',
                  step: '1',
                }}
                disabled={this.hasTicketNFCRole()}
              />

              <TextField
                className="input-text-field"
                variant="outlined"
                label="Amount"
                InputLabelProps={{ shrink: true }}
                name="ticketOut"
                value={this.state.ticketOut}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                onChange={this.handleChange}
                required={this.state.requiredList.includes('ticketOut')}
                type="tel"
                inputRef={this.amountRef}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  min: '0',
                  step: '1',
                }}
              />
            </div>

            <div className="amount-buttons">
              <div style={{ marginBottom: '20px' }}>
                {Object.keys(amounts).map((amount) => (
                  <button
                    key={amount}
                    onClick={() => this.handleClick(amount)}
                    style={{
                      margin: '5px',
                      padding: '10px 20px',
                      backgroundColor: '#2596be',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    {amount}
                  </button>
                ))}

                <button
                  onClick={this.clearAmounts}
                  style={{
                    margin: '5px',
                    padding: '10px 20px',
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  CLR
                </button>
              </div>
            </div>

            <div className="button-ticket">
              <Button
                variant="outlined"
                onClick={this.clearFields}
                className="register-new-user_btn"
              >
                CLEAR
              </Button>
              <Button
                className="register-new-user_btn"
                variant="contained"
                color="primary"
                onClick={() => this.addTicket()}
                disabled={
                  !(this.state.machine && this.state.ticketOut) ||
                  this.state.saving ||
                  this.state.waiting
                }
              >
                {this.state.saving ? 'SAVING...' : 'ADD TICKET'}
              </Button>
            </div>

            {this.displayCurrentPage()}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  ticketOut: ticketOutSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  companies: companySelector(state),
});

const actionCreators = {
  clearStatus,
  listTicketOut,
  deleteTicketOut,
  saveTicketOut,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  TicketOut
);
